import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import { getLeadByID, notQualifiedLeadPost } from '../../redux/reduxActions/leadActions';
import { showToastError } from '../utils';

const NotQualifiedLead = (props) => {
  const { selectedLead: { id} } = props;
  const [comment, setComment] = useState('');
  useEffect(() => {
    props.getLeadByID(props.match.params.id);
  }, []);
  function notQualifiedLeadAplly() {
    if (!comment) {
      showToastError('Reason field is empty!!!');
    } else {
      props.notQualifiedLeadPost(id, {comment }).then(() => {
          props.history.push(window.history.back());
      })
    }
  }
  return (
    <div>
        <div className="lead__container" style={{ minHeight: 'auto', border:'none' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
            <h3 style={{ color: '#383838', marginBottom: 0, height: 'min-content' }}>
                Not_Qualified.Lead Action
            </h3>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '200px',
              }}
            >
              <Button
                onClick={() => window.history.back()}
                size="sm"
                id="apply-filter"
              >
                Cancel
              </Button>
              <Button
                onClick={() => { notQualifiedLeadAplly(); }}
                size="sm"
                id="apply-filter"
              >
                Apply
              </Button>
            </div>
          </div>
          <div className="lead__container__inner" style={{marginLeft: 30, marginTop: 20, marginBottom: 16, justifyContent:'space-between' }}>
            <div>
              <p className="lead__title">
                Reason
                <span style={{ color: 'red' }}>*</span>
              </p>
            </div>
            <TextareaAutosize
              onChange={(e) => setComment(e.target.value)}
              className="lead__textarea lead__input"
              rows={1}
              style={{ width: '80%', padding: 10 }}
              placeholder="..."
            />
          </div>
        </div>
    </div>
  );
};
export default connect((state) => ({
  responsible: state.leadReducer.responsible,
  selectedLead: state.leadReducer.selectedLead,
}), { getLeadByID, notQualifiedLeadPost })(NotQualifiedLead);
